
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskTemplateModel } from './Entities.GormCrm.TaskTemplate';
import { Model, ModelProperty } from 'models/Model';


export class TaskTemplateTagModel extends Model<TaskTemplateTagModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string' },
		{ name: 'taskTemplateId', type: 'string' },
		{ name: 'taskTemplate', type: 'TaskTemplateModel', isHidden: true, isObject: true, new: () => { return new TaskTemplateModel }, properties: () => { return TaskTemplateModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public taskTemplateId?: string;
	public taskTemplate?: TaskTemplateModel;
    
	constructor(){
		super();
		this.tag = '';
		this.taskTemplateId = undefined;
		this.taskTemplate = undefined;
		
	}
	getProperties(){
		return TaskTemplateTagModel.classProperties;
	}
}

